<template>
  <div class="dashboard-container">

    <b-modal id="customer-select-modal" hide-footer :hide-header-close="true" size="l" no-close-on-backdrop
      no-close-on-esc centered title="Chọn khách hàng để bắt đầu">
      <b-container>

        <InputFilterDashboard placeholder="Nhập tên hoặc số điện thoại" @viewUser="handleSelectCustomer"
          class="form__search" :options="[]" />
        <b-button class="btn btn-light ml-3" @click="$bvModal.hide('customer-select-modal')" type="button"
          style="float: right">

          Đóng
        </b-button>
      </b-container>
    </b-modal>
    <!-- Main Content - Chỉ hiển thị khi đã chọn khách hàng -->
    <div>

      <!-- Patient Overview Section -->
      <section class="patient-overview">
        <div class="overview-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
              fill="currentColor" />
            <path d="M10 12C4.47715 12 0 14.4772 0 17.5V20H20V17.5C20 14.4772 15.5228 12 10 12Z" fill="currentColor" />
          </svg>
          <h2 class="patient-name">{{ userInformation.name || "Khách hàng" }}</h2>
          <span>{{ userInformation.phoneNumber || "Phone" }}</span>
        </div>

        <div class="patient-info">
          <div class="patient-basic">
            <span class="patient-meta">{{ formatDate(userInformation.birthday) || "DateOfBirth" }} {{
              userInformation.gender }}</span>
            <span class="patient-meta">{{ userInformation.typeOfSick }}</span>
            <span class="risk-badge">{{ patientData.riskLevel }}</span>
          </div>
          <div class="patient-next">
            <div class="next-appointment">
              <span class="next-label">Next: {{ patientData.nextAppointment }}</span>
            </div>
            <div class="alerts-badge">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 0L9.5 5.5L15 7L9.5 8.5L8 14L6.5 8.5L1 7L6.5 5.5L8 0Z" />
              </svg>
              <span>{{ patientData.alerts }} alerts</span>

            </div>
            <b-button class="btn btn-success" @click="loadUserData()">Làm mới</b-button>
            <b-button class="btn btn-success" @click="$bvModal.show('customer-select-modal')">Tìm kiếm</b-button>

          </div>

        </div>
      </section>

      <!-- Tab Navigation -->
      <nav class="tab-navigation">
        <button v-for="tab in tabs" :key="tab.id" :class="['tab-button', { active: activeTab === tab.id }]"
          @click="activeTab = tab.id">
          {{ tab.label }}
        </button>
      </nav>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Clinical Dashboard Tab -->
        <div v-if="activeTab === 'clinical'" class="clinical-dashboard">
          <!-- Charts Grid -->
          <div class="charts-grid">
            <div v-for="chart in charts" :key="chart.id" class="chart-card">
              <div class="chart-header">
                <h3>{{ chart.title }}</h3>
                <span :class="['status-badge', chart.status.toLowerCase()]">{{ chart.status }}</span>
              </div>

              <!-- Time Range Filter - RIÊNG CHO TỪNG CHART -->
              <div class="chart-filter-wrapper">
                <basic-select v-model="chart.selectedOption" :options="getTimeRangeOptions(chart.id)"
                  :value.sync="chart.periodFilterType" :solid="false" :allowEmpty="false" trackBy="value"
                  valueLabel="label" @input="(value) => onChartFilterChange(chart.id, value)" />
              </div>

              <div class="chart-body">
                <!-- Loading Overlay -->
                <b-overlay :show="getChartLoading(chart)" variant="white" opacity="0.85">
                  <template #overlay>
                    <div class="text-center">
                      <b-spinner variant="primary"></b-spinner>
                      <p class="mt-2 text-muted small">Đang tải dữ liệu...</p>
                    </div>
                  </template>

                  <!-- Chart Content -->
                  <div class="chart-container" v-if="hasChartData(chart)">
                    <apexchart class="card-rounded-bottom" :options="getChartOptions(chart)"
                      :series="getChartSeries(chart)" type="line">
                    </apexchart>
                  </div>

                  <!-- No Data State -->
                  <div v-else class="chart-no-data">
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                      <circle cx="30" cy="30" r="28" stroke="#E5E7EB" stroke-width="2" />
                      <path d="M15 30 L25 20 L35 30 L45 20" stroke="#9CA3AF" stroke-width="2" fill="none" />
                    </svg>
                    <p>Chưa có dữ liệu</p>
                  </div>
                </b-overlay>
              </div>
            </div>
          </div>

          <!-- Lab Results Section -->
          <section class="lab-results">
            <div class="section-header">
              <h2>🔬 Detailed Lab Results</h2>
              <div class="section-actions">
                <input type="text" placeholder="Search tests..." class="search-input">
                <button class="action-btn">All view</button>
                <button class="action-btn">All tests</button>
              </div>
            </div>

            <b-overlay :show="labResultsLoading" variant="white">
              <table class="results-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Test Name</th>
                    <th>Value</th>
                    <th>Reference Range</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="result in labResults" :key="result.id">

                    <td>{{ result.date }}</td>
                    <td>{{ result.testName }}</td>
                    <td class="value-cell">{{ result.value }}</td>
                    <td>{{ result.range }}</td>
                    <td><span :class="['status-badge', result.status.toLowerCase()]">{{ result.status }}</span></td>
                  </tr>
                </tbody>
              </table>
            </b-overlay>
          </section>

          <!-- Clinical Sidebar -->
          <div class="clinical-sidebar">
            <!-- Clinical Notes -->
            <section class="clinical-notes">
              <h3>📋 Clinical Notes</h3>
              <div class="note-card">
                <div class="note-header">
                  <span class="note-type">Examination</span>
                  <span class="note-date">10/15/2024</span>
                </div>
                <div class="note-content" v-html="clinicalNote"></div>
              </div>
            </section>

            <!-- Follow-up -->
            <section class="follow-up">
              <h3>📅 Follow-up</h3>
              <div class="followup-date">10/30/2024</div>
              <div class="followup-content" v-html="followUpNote"></div>
            </section>

            <!-- Patient Symptoms -->
            <section class="symptoms">
              <h3>🩺 Patient Symptoms</h3>
              <div v-for="symptom in symptoms" :key="symptom.id" class="symptom-item">
                <div class="symptom-header">
                  <span>{{ symptom.name }}</span>
                  <span :class="['severity-badge', symptom.severity.toLowerCase()]">{{ symptom.severity }}</span>
                </div>
                <div class="symptom-details">
                  <span>Duration: {{ symptom.duration }}</span>
                  <span>Severity: {{ symptom.level }}</span>
                  <span>Date: {{ symptom.date }}</span>
                </div>
              </div>
            </section>

            <!-- Clinical Contact Summary -->
            <section class="contact-summary">
              <h3>📊 Clinical Contact Summary</h3>
              <div v-for="item in contactSummary" :key="item.id" class="summary-item">
                <span>{{ item.label }}</span>
                <span :class="['status-badge', item.status.toLowerCase()]">{{ item.status }}</span>
              </div>
            </section>

            <!-- Upcoming Appointments -->
            <section class="appointments">
              <h3>📅 Upcoming Appointments</h3>
              <p class="no-data">No upcoming appointments scheduled</p>
            </section>

            <!-- Overdue Tests -->
            <section class="overdue-tests">
              <h3>⚠️ Overdue Tests</h3>
              <div v-for="test in overdueTests" :key="test.id" class="test-card">
                <h4>{{ test.name }}</h4>
                <div class="test-details">
                  <span :class="['priority-badge', test.priority.toLowerCase().replace(' ', '-')]">{{ test.priority
                  }}</span>
                  <div class="test-info">
                    <p><strong>Due:</strong> {{ test.due }}</p>
                    <p><strong>Ordered:</strong> {{ test.ordered }}</p>
                    <p><strong>Indication:</strong> {{ test.indication }}</p>
                  </div>
                  <button class="schedule-btn">{{ test.action }}</button>
                </div>
              </div>
            </section>

            <!-- Upcoming Tests -->
            <section class="upcoming-tests">
              <h3>🧪 Upcoming Tests</h3>
              <p class="no-data">No upcoming tests scheduled</p>
            </section>

            <!-- Quick Actions -->
            <section class="quick-actions">
              <h3>⚡ Quick Actions</h3>
              <button class="action-button">📅 Schedule Follow-up Appointment</button>
              <button class="action-button">📝 Order Lab Tests</button>
              <button class="action-button">🔔 Set Care Reminder</button>
            </section>
          </div>
        </div>

        <!-- Insights & Recommendations Tab -->
        <div v-if="activeTab === 'insights'" class="insights-tab">
          <section class="ai-insights">
            <div class="insights-header">
              <h2>🤖 AI-Generated Insights & Recommendations</h2>
              <p>Based on patient data analysis and clinical guidelines</p>
            </div>

            <b-overlay :show="false" variant="white">
              <div class="recommendations-grid">
                <div v-for="rec in recommendations" :key="rec.id" class="recommendation-card">
                  <div class="rec-header">
                    <div class="rec-title">
                      <span class="rec-icon">{{ rec.icon }}</span>
                      <h3>{{ rec.title }}</h3>
                    </div>
                    <div class="rec-badges">
                      <span :class="['priority-badge', rec.priority.toLowerCase()]">{{ rec.priority }}</span>
                      <span :class="['type-badge', rec.type.toLowerCase()]">{{ rec.type }}</span>
                    </div>
                  </div>
                  <p class="rec-description">{{ rec.description }}</p>
                  <div class="rec-evidence">
                    <strong>Evidence:</strong>
                    <p>{{ rec.evidence }}</p>
                  </div>
                  <div class="rec-footer">
                    <span class="confidence">Confidence: <strong
                        :style="{ color: getConfidenceColor(rec.confidence) }">{{
                          rec.confidence }}</strong></span>
                    <button class="rec-action-btn">{{ rec.action }}</button>
                  </div>
                </div>
              </div>

              <!-- Summary Stats -->
              <div class="summary-stats">
                <div class="stat-card">
                  <div class="stat-number high-priority">2</div>
                  <div class="stat-label">High Priority</div>
                </div>
                <div class="stat-card">
                  <div class="stat-number medication">1</div>
                  <div class="stat-label">Medication</div>
                </div>
                <div class="stat-card">
                  <div class="stat-number lifestyle">1</div>
                  <div class="stat-label">Lifestyle</div>
                </div>
                <div class="stat-card">
                  <div class="stat-number confidence">90%</div>
                  <div class="stat-label">Avg Confidence</div>
                </div>
              </div>
            </b-overlay>
          </section>
        </div>

        <!-- Patient Profile Tab -->
        <div v-if="activeTab === 'profile'" class="profile-tab">
          <!-- Demographics -->
          <section class="profile-section">
            <h2>👤 Demographics</h2>
            <div class="demographics-grid">
              <div class="demo-item">
                <label>Full Name</label>
                <p>{{ userInformation.name }}</p>
              </div>
              <div class="demo-item">
                <label>Patient ID</label>
                <p>{{ userInformation.patientId }}</p>
              </div>
              <div class="demo-item">
                <label>Date of Birth</label>
                <p>{{ formatDateTime(userInformation.birthday) }}</p>
              </div>
              <div class="demo-item">
                <label>PHONE</label>
                <p>{{ userInformation.phoneNumber }}</p>
              </div>
              <div class="demo-item">
                <label>Gender</label>
                <p>{{ userInformation.gender }}</p>
              </div>
              <div class="demo-item">
                <label>📧</label>
                <p>{{ userInformation.email }}</p>
              </div>
              <div class="demo-item">
                <label>📍</label>
                <p>{{ userInformation.address }}</p>
              </div>
            </div>
          </section>

          <!-- Emergency Contact -->
          <section class="profile-section">
            <h2>🚨 Emergency Contact</h2>
            <div class="emergency-info">
              <p><strong>Name:</strong> {{ profileData.emergencyContact.name }}</p>
              <p><strong>Relationship:</strong> {{ profileData.emergencyContact.relationship }}</p>
              <p><strong>Phone:</strong> {{ profileData.emergencyContact.phone }}</p>
            </div>
          </section>

          <!-- Medical History -->
          <section class="profile-section">
            <h2>❤️ Medical History</h2>
            <div class="medical-history">
              <div class="history-item">
                <strong>Primary Diagnosis</strong>
              </div>
              <div class="history-item">
                <strong>Secondary Diagnoses</strong>
                <div class="tags">
                  <span class="tag">Hypertension</span>
                  <span class="tag">Dyslipidemia</span>
                  <span class="tag">Obesity</span>
                </div>
              </div>
              <div class="history-item">
                <strong>Medical History</strong>
                <ul class="history-list">
                  <li>Diagnosed with Type 2 Diabetes in 2008</li>
                  <li>History of gestational diabetes (1995, 1998)</li>
                  <li>Family history of diabetes (mother, maternal grandfather)</li>
                  <li>Previous myocardial infarction (2022)</li>
                </ul>
              </div>
            </div>
          </section>

          <!-- Current Medications -->
          <section class="profile-section">
            <h2>💊 Current Medications</h2>
            <div class="medications-list">
              <div v-for="med in medications" :key="med.id" class="medication-card">
                <h3>{{ med.name }}</h3>
                <p><strong>Dosage:</strong> {{ med.dosage }}</p>
                <p><strong>Frequency:</strong> {{ med.frequency }}</p>
                <p><strong>Prescribed by:</strong> {{ med.prescriber }}</p>
                <p><strong>Started:</strong> {{ med.started }}</p>
              </div>
            </div>
          </section>

          <!-- Allergies -->
          <section class="profile-section">
            <h2>⚠️ Allergies</h2>
            <div class="allergies-list">
              <div v-for="allergy in allergies" :key="allergy.id" class="allergy-item">
                <div class="allergy-header">
                  <strong>{{ allergy.name }}</strong>
                  <span :class="['severity-badge', allergy.severity.toLowerCase()]">{{ allergy.severity }}</span>
                </div>
                <p>{{ allergy.reaction }}</p>
              </div>
            </div>
          </section>

          <!-- Insurance Information -->
          <section class="profile-section">
            <h2>🏥 Insurance Information</h2>
            <div class="insurance-info">
              <p><strong>Provider:</strong> {{ profileData.insurance.provider }}</p>
              <p><strong>Policy Number:</strong> {{ profileData.insurance.policyNumber }}</p>
              <p><strong>Group Number:</strong> {{ profileData.insurance.groupNumber }}</p>
            </div>
          </section>

          <!-- Care Team -->
          <section class="profile-section">
            <h2>👥 Care Team</h2>
            <div class="care-team-list">
              <div v-for="member in careTeam" :key="member.id" class="team-member">
                <h3>{{ member.name }}</h3>
                <p class="member-role">{{ member.role }}</p>
                <p><strong>Department:</strong> {{ member.department }}</p>
                <p><strong>Phone:</strong> {{ member.phone }}</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import InputFilterDashboard from '../user_dashboard/components/InputFilterDashboard.vue'
import { convertTimestampToYear, convertTimestampToDateTime } from '../../../core/utils/dateUtils'
import { healthService } from './services/healthService';

export default {
  name: 'DashboardDoctorView',
  components: {
    InputFilterDashboard
  },

  data() {
    return {
      activeTab: 'clinical',
      hoveredPoint: null,

      tabs: [
        { id: 'clinical', label: 'Clinical Dashboard' },
        { id: 'insights', label: 'Insights & Recommendations' },
        { id: 'profile', label: 'Patient Profile' }
      ],

      patientData: {
        riskLevel: 'HIGH',
        nextAppointment: 'November 12, 2024',
        alerts: 3
      },

      charts: [
        { id: 1, title: 'Blood Glucose', status: 'Critical', color: '#3b82f6', labels: [], periodFilterType: 1 },
        { id: 2, title: 'HbA1C', status: 'High', color: '#ef4444', labels: [], periodFilterType: 1 },
        { id: 3, title: 'Blood Pressure', status: 'Normal', colors: ['#ef4444', '#3b82f6'], labels: [], periodFilterType: 1 },
        { id: 4, title: 'BMI / Weight', status: 'Increasing', color: '#f59e0b', labels: [], periodFilterType: 1 }
      ],

      labResults: [
        { id: 1, date: '10/31/2024', testName: 'HbA1c', value: '8.4%', range: '4 - 5.6%', status: 'High' },
        { id: 2, date: '10/31/2024', testName: 'Fasting Glucose', value: '215 mg/dL', range: '70 - 100 mg/dL', status: 'Critical' },
        { id: 3, date: '10/31/2024', testName: 'Creatinine', value: '1.4 mg/dL', range: '0.6 - 1.2 mg/L', status: 'High' },
        { id: 4, date: '10/31/2024', testName: 'eGFR', value: '52', range: '> 60', status: 'Low' },
        { id: 5, date: '10/31/2024', testName: 'Total Cholesterol', value: '208 mg/dL', range: '< 200 mg/dL', status: 'High' },
        { id: 6, date: '9/15/2024', testName: 'HbA1c', value: '8.3%', range: '4 - 5.6%', status: 'High' }
      ],

      clinicalNote: `
        <strong>Current patient concerning symptoms:</strong> 
        Blood pressure elevated at 155/98. Functionality assessment shows 
        <strong>stress from work.</strong> Discussed <strong>confidence management.</strong>.
      `,

      followUpNote: `
        Lab results show deteriorating kidney function with <strong>eGFR at 52</strong>. 
        HbA1c remains elevated. Patient reports increased thirst and fatigue. 
        Weight gain 5kg since last visit. Medication adherence good.
      `,

      symptoms: [
        { id: 1, name: 'Increased thirst and urination', severity: 'moderate', duration: '2 weeks', level: 'Moderate', date: '10/15/2024' },
        { id: 2, name: 'Fatigue and weakness', severity: 'moderate', duration: '1 month', level: 'Moderate', date: '10/01/2024' },
        { id: 3, name: 'Blurred vision episodes', severity: 'mild', duration: 'Intermittent', level: 'Mild', date: '09/28/2024' }
      ],

      contactSummary: [
        { id: 1, label: 'Symptom Severity Trend', status: 'Increasing' },
        { id: 2, label: 'Patient Compliance', status: 'Good' },
        { id: 3, label: 'Follow-up Priority', status: 'Medium' }
      ],

      overdueTests: [
        { id: 1, name: 'HbA1c', priority: 'high priority', due: 'Overdue', ordered: 'Every 3 months', indication: 'Diabetes monitoring', action: 'Schedule now' },
        { id: 2, name: 'Comprehensive Metabolic Panel', priority: 'high priority', due: 'Overdue', ordered: 'Every 3 months', indication: 'Kidney function', action: 'Schedule now' },
        { id: 3, name: 'Liver Ultrasound', priority: 'medium priority', due: 'Overdue', ordered: 'Annual', indication: 'Fatty liver monitoring', action: 'Schedule' }
      ],

      recommendations: [
        {
          id: 1,
          icon: '🚨',
          title: 'Urgent Nephrology Consultation',
          priority: 'high',
          type: 'referral',
          description: 'Declining kidney function with eGFR below 60 and rising creatinine indicates progressive diabetic nephropathy requiring specialist evaluation.',
          evidence: 'Creatinine 1.4 mg/dL (previous 1.1), eGFR 52 mL/min/1.73m²',
          confidence: '95%',
          action: 'Schedule nephrology'
        },
        {
          id: 2,
          icon: '💊',
          title: 'Consider Insulin Therapy Initiation',
          priority: 'high',
          type: 'medication',
          description: "Patient's HbA1c has remained above 8% despite optimal oral medication therapy. Trend suggests beta-cell dysfunction.",
          evidence: 'HbA1c 8.4%, fasting glucose 215 mg/dL, +15% in 2 months',
          confidence: '92%',
          action: 'Initiate basal insulin'
        }
      ],

      profileData: {
        fullName: 'Sarah Johnson',
        patientId: 'PT-2024-0892',
        dob: 'March 15, 1966 (Age: 58)',
        phone: '(555) 123-4567',
        gender: 'Female',
        email: 'sarah.johnson@email.com',
        address: '1234 Oak Street, Springfield, IL 62701',
        emergencyContact: {
          name: 'Michael Johnson',
          relationship: 'Spouse',
          phone: '(555) 987-6543'
        },
        insurance: {
          provider: 'Blue Cross Blue Shield',
          policyNumber: 'BC123456789',
          groupNumber: 'GRP789012'
        }
      },

      medications: [
        { id: 1, name: 'Metformin', dosage: '1000mg', frequency: 'Twice daily', prescriber: 'Dr. Smith', started: 'January 2018' },
        { id: 2, name: 'Lisinopril', dosage: '10mg', frequency: 'Once daily', prescriber: 'Dr. Smith', started: 'March 2020' },
        { id: 3, name: 'Atorvastatin', dosage: '20mg', frequency: 'Once daily', prescriber: 'Dr. Smith', started: 'June 2022' }
      ],

      allergies: [
        { id: 1, name: 'Penicillin', severity: 'severe', reaction: 'Anaphylaxis' },
        { id: 2, name: 'Shellfish', severity: 'moderate', reaction: 'Hives and swelling' }
      ],

      careTeam: [
        { id: 1, name: 'Dr. Emily Smith', role: 'Primary Care Physician', department: 'Internal Medicine', phone: '(555) 234-5678' },
        { id: 2, name: 'Dr. Robert Chen', role: 'Endocrinologist', department: 'Endocrinology', phone: '(555) 345-6789' },
        { id: 3, name: 'Sarah Wilson, RN', role: 'Diabetes Care Nurse', department: 'Diabetes Care', phone: '(555) 456-7890' }
      ],

      userInformation: {},

      // Loading states
      trendGlucoseLoading: false,
      pressureLoading: false,
      hba1cLoading: false,
      bmiLoading: false,
      labResultsLoading: false,

      // Chart data
      glucoseChartData: null,
      bloodPressureChartData: null,
      hba1cChartData: null,
      bmiChartData: null,


      timeRangeOptions: [
        { label: '7 ngày', value: 1 },
        { label: '14 ngày', value: 2 },
        { label: '30 ngày', value: 3 },
        { label: '90 ngày', value: 4 }
      ],
      hba1cTimeRangeOptions: [
        { label: '6 tháng', value: 1 },
        { label: '1 năm', value: 2 },
        { label: '2 năm', value: 3 }
      ],

      timeRangeMapping: {
        1: 7,
        2: 14,
        3: 30,
        4: 90
      }
    }
  },

  methods: {
    getTimeRangeOptions(chartId) {
      if (chartId === 2) { // HbA1c chart
        return this.hba1cTimeRangeOptions
      }
      return this.timeRangeOptions // Các charts khác dùng options bình thường
    },

    async handleViewUser(item) {
      this.userInformation = item
      await this.loadUserData()
      console.log('📥 Dữ liệu từ InputFilter:', this.userInformation)
    },

    async loadUserData() {
      if (!this.userInformation.patientId) return

      // Load tất cả charts với filter riêng của từng chart
      await Promise.all([
        this.loadSingleChart(1, this.charts[0].periodFilterType), // Glucose
        this.loadSingleChart(2, this.charts[1].periodFilterType), // HbA1c
        this.loadSingleChart(3, this.charts[2].periodFilterType), // Blood Pressure
        this.loadSingleChart(4, this.charts[3].periodFilterType)  // BMI
      ])
    },

    getDateRange(filterType) {
      const days = this.timeRangeMapping[filterType] || 7
      const toDate = Math.floor(Date.now() / 1000)
      const fromDate = toDate - (days * 24 * 60 * 60)
      return { fromDate, toDate }
    },

    // Xử lý khi thay đổi filter của từng chart - ĐỘC LẬP
    async onChartFilterChange(chartId, filterValue) {
      const chart = this.charts.find(c => c.id === chartId)
      if (!chart || !this.userInformation.patientId) return

      console.log(`📊 Chỉ load lại Chart ${chartId} (${chart.title}) với filter: ${filterValue}`)

      // Cập nhật periodFilterType CHỈ của chart này
      chart.periodFilterType = filterValue

      // CHỈ reload data của chart này, KHÔNG ảnh hưởng các chart khác
      await this.loadSingleChart(chartId, filterValue)
    },

    // Load data cho 1 chart cụ thể - KHÔNG ảnh hưởng charts khác
    async loadSingleChart(chartId, periodFilterType) {
      const { fromDate, toDate } = this.getDateRange(periodFilterType)
      const searchParams = {
        currentDateTime: toDate,
        periodFilterType: periodFilterType,
        fromDate: fromDate,
        toDate: toDate,
        takeAll: true,
        trendType: periodFilterType
      }

      const chartNames = {
        1: 'Glucose',
        2: 'HbA1c',
        3: 'Blood Pressure',
        4: 'BMI'
      }

      console.log(`🔄 Đang load ${chartNames[chartId]} với ${this.timeRangeMapping[periodFilterType]} ngày`)

      // Chỉ gọi API cho chart được chọn
      switch (chartId) {
        case 1: // Glucose
          await this.loadTrendGlucose(searchParams)
          break
        case 2: // HbA1c
          await this.loadHba1cTrend(searchParams)
          break
        case 3: // Blood Pressure
          await this.loadTrendPressure(searchParams)
          break
        case 4: // BMI
          await this.loadBmiTrend(searchParams)
          break
      }

      console.log(`✅ Hoàn thành load ${chartNames[chartId]}`)
    },

    async loadTrendGlucose(searchParams) {
      this.trendGlucoseLoading = true
      try {
        if (!this.userInformation.patientId) return

        const raw = await healthService.getGlucoseTrend(
          this.$api,
          this.userInformation.patientId,
          searchParams
        )

        this.glucoseChartData = healthService.formatGlucoseTrendToChart(raw)

        const chart = this.charts.find(c => c.id === 1)
        if (chart) {
          chart.labels = this.glucoseChartData.labels
          chart.color = this.glucoseChartData.color
          chart.status = 'Updated'
        }
      } catch (err) {
        console.error('❌ Error loading glucose:', err)
        this.$toastr.e(err.message || 'Lỗi tải dữ liệu glucose', 'ERROR')
      } finally {
        this.trendGlucoseLoading = false
      }
    },

    async loadTrendPressure(searchParams) {
      this.pressureLoading = true
      try {
        const response = await healthService.getBloodPressureTrend(
          this.$api,
          this.userInformation.patientId,
          searchParams
        )

        this.bloodPressureChartData = healthService.formatBloodPressureTrendToChart(response)

        const chart = this.charts.find(c => c.id === 3)
        if (chart) {
          chart.labels = this.bloodPressureChartData.labels
          chart.status = 'Updated'
        }
      } catch (err) {
        console.error('❌ Lỗi huyết áp:', err)
      } finally {
        this.pressureLoading = false
      }
    },

    async loadHba1cTrend(searchParams) {
      this.hba1cLoading = true
      try {
        if (!this.userInformation.patientId) return

        const raw = await healthService.getHba1cTrend(
          this.$api,
          this.userInformation.patientId,
          searchParams
        )

        this.hba1cChartData = healthService.formatHba1cTrendToChart(raw)

        const chart = this.charts.find(c => c.id === 2)
        if (chart) {
          chart.labels = this.hba1cChartData.labels
          chart.color = this.hba1cChartData.color
          chart.status = 'Updated'
        }
      } catch (err) {
        console.error('❌ Lỗi load HbA1C:', err)
      } finally {
        this.hba1cLoading = false
      }
    },

    async loadBmiTrend(searchParams) {
      this.bmiLoading = true
      try {
        if (!this.userInformation.patientId) return

        const raw = await healthService.getBmiTrend(
          this.$api,
          this.userInformation.patientId,
          searchParams
        )

        this.bmiChartData = healthService.formatBmiTrendToChart(raw)

        const chart = this.charts.find(c => c.id === 4)
        if (chart) {
          chart.labels = this.bmiChartData.labels
          chart.color = this.bmiChartData.color
          chart.status = 'Updated'
        }
      } catch (err) {
        console.error('❌ Lỗi load BMI:', err)
      } finally {
        this.bmiLoading = false
      }
    },

    getChartLoading(chart) {
      const loadingMap = {
        1: this.trendGlucoseLoading,
        2: this.hba1cLoading,
        3: this.pressureLoading,
        4: this.bmiLoading
      }
      return loadingMap[chart.id] || false
    },

    hasChartData(chart) {
      const dataMap = {
        1: this.glucoseChartData,
        2: this.hba1cChartData,
        3: this.bloodPressureChartData,
        4: this.bmiChartData
      }
      return dataMap[chart.id] && dataMap[chart.id].labels && dataMap[chart.id].labels.length > 0
    },

    getChartOptions(chart) {
      let labels = chart.labels
      let colors = [chart.color]

      if (chart.id === 1 && this.glucoseChartData) {
        labels = this.glucoseChartData.labels
        colors = [this.glucoseChartData.color]
      }
      if (chart.id === 3 && this.bloodPressureChartData) {
        labels = this.bloodPressureChartData.labels
        colors = this.bloodPressureChartData.colors
      }
      if (chart.id === 2 && this.hba1cChartData) {
        labels = this.hba1cChartData.labels
        colors = [this.hba1cChartData.color]
      }
      if (chart.id === 4 && this.bmiChartData) {
        labels = this.bmiChartData.labels
        colors = [this.bmiChartData.color]
      }

      return {
        chart: {
          height: 250,
          type: 'line',
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        stroke: {
          width: 2.5,
          curve: 'smooth',
          colors: colors
        },
        markers: {
          size: 6,
          colors: colors,
          strokeColors: '#fff',
          strokeWidth: 2,
          hover: { size: 8 }
        },
        xaxis: {
          categories: labels,
          labels: {
            style: { colors: '#888', fontSize: '12px' }
          }
        },
        yaxis: {
          show: true,
          labels: {
            style: { colors: '#888', fontSize: '11px' }
          }
        },
        grid: {
          show: true,
          borderColor: '#f3f4f6',
          strokeDashArray: 3
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false
        },
        legend: {
          show: chart.id === 3,
          position: 'top'
        }
      }
    },

    getChartSeries(chart) {
      if (chart.id === 1 && this.glucoseChartData) {
        return [{ name: 'Glucose (mg/dL)', data: this.glucoseChartData.values }]
      }
      if (chart.id === 2 && this.hba1cChartData) {
        return [{ name: 'HbA1C (%)', data: this.hba1cChartData.values }]
      }
      if (chart.id === 3 && this.bloodPressureChartData) {
        return [
          { name: 'Tâm thu (Systolic)', data: this.bloodPressureChartData.systolicValues },
          { name: 'Tâm trương (Diastolic)', data: this.bloodPressureChartData.diastolicValues }
        ]
      }
      if (chart.id === 4 && this.bmiChartData) {
        return [{ name: 'BMI', data: this.bmiChartData.bmiValues }]
      }
      return []
    },

    formatDate(timestamp) {
      return convertTimestampToYear(timestamp)
    },
    formatDateTime(timestamp) {
      return convertTimestampToDateTime(timestamp)
    },
    getConfidenceColor(confidence) {
      const numeric = parseFloat(confidence)
      if (isNaN(numeric)) return '#6b7280' // gray fallback
      if (numeric >= 90) return '#16a34a'  // green (high confidence)
      if (numeric >= 70) return '#f59e0b'  // yellow (medium)
      return '#dc2626'                     // red (low)
    },
    handleSelectCustomer(user) {
      this.userInformation = user;
      this.$bvModal.hide('customer-select-modal');
      this.loadUserData();
    }
  },

  mounted() {
    if (!this.userInformation?.phoneNumber) {
      this.charts.forEach(chart => {
        chart.selectedOption = this.timeRangeOptions.find(opt => opt.value === 1)
        chart.periodFilterType = 1
      })

      this.$bvModal.show('customer-select-modal');
    }
  },
  created() {
    this.$store.dispatch('layout/toggleSidebar', false);

  }
  ,
  watch: {
    userInformation: {
      handler(newValue) {
        if (newValue && newValue.patientId) {
          this.loadUserData()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
/* Empty State Styles */
.empty-state-container {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.empty-state-content {
  text-align: center;
  padding: 3rem;
  max-width: 500px;
}

.empty-state-icon {
  margin-bottom: 2rem;
  opacity: 0.8;
}

.empty-state-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
}

.empty-state-description {
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.6;
}

/* Chart No Data State */
.chart-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  color: #9CA3AF;
}

.chart-no-data svg {
  margin-bottom: 1rem;
  opacity: 0.5;
}

.chart-no-data p {
  font-size: 0.9rem;
  font-weight: 500;
}

/* Chart Filter Wrapper */
.chart-filter-wrapper {
  margin-bottom: 1rem;
}

/* Existing styles continue... */
.dashboard-container {
  width: 100%;
  background: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #1f2937;
}

.patient-overview {
  background: white;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.overview-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4b5563;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.patient-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.patient-basic {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.patient-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.patient-meta {
  color: #6b7280;
  font-size: 0.95rem;
}

.risk-badge {
  background: #fef2f2;
  color: #dc2626;
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.patient-next {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.next-label {
  color: #6b7280;
  font-size: 0.9rem;
}

.alerts-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fef3c7;
  color: #d97706;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.tab-navigation {
  background: white;
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e5e7eb;
}

.tab-button {
  flex: 1;
  padding: 1rem 2rem;
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background: #f9fafb;
  color: #111827;
}

.tab-button.active {
  color: #008479;
  border-bottom-color: #008479;
  background: #eff6ff;
}

.tab-content {
  padding: 2rem;
}

/* Clinical Dashboard Styles */
.clinical-dashboard {
  display: grid;
  gap: 2rem;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
}

.chart-card {
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.chart-header h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge.critical {
  background: #fef2f2;
  color: #dc2626;
}

.status-badge.high {
  background: #fef2f2;
  color: #dc2626;
}

.status-badge.normal {
  background: #f0fdf4;
  color: #16a34a;
}

.status-badge.monitor {
  background: #fef9c3;
  color: #ca8a04;
}

.status-badge.declining {
  background: #fef3c7;
  color: #d97706;
}

.status-badge.increasing {
  background: #fff7ed;
  color: #ea580c;
}

.chart-body {
  position: relative;
}

.chart-container {
  position: relative;
}

.chart-svg {
  width: 100%;
  height: 120px;
  margin-bottom: 0.5rem;
}

.chart-tooltip {
  position: absolute;
  background: rgba(17, 24, 39, 0.95);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.85rem;
  pointer-events: none;
  z-index: 10;
  transform: translateX(-50%);
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.chart-tooltip::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(17, 24, 39, 0.95);
}

.tooltip-value {
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.tooltip-label {
  font-size: 0.75rem;
  opacity: 0.8;
}

.chart-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #9ca3af;
  padding: 0 0.5rem;
}

/* Lab Results */
.lab-results {
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.section-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
}

.section-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.search-input {
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  width: 200px;
}

.action-btn {
  padding: 0.5rem 1rem;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  background: #e5e7eb;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
}

.results-table thead {
  background: #f9fafb;
}

.results-table th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.85rem;
  color: #6b7280;
  border-bottom: 2px solid #e5e7eb;
}

.results-table td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  font-size: 0.9rem;
}

.value-cell {
  font-weight: 600;
  color: #111827;
}

/* Clinical Sidebar */
.clinical-sidebar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
}

.clinical-notes,
.follow-up,
.symptoms,
.contact-summary,
.appointments,
.overdue-tests,
.upcoming-tests,
.quick-actions {
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.clinical-notes h3,
.follow-up h3,
.symptoms h3,
.contact-summary h3,
.appointments h3,
.overdue-tests h3,
.upcoming-tests h3,
.quick-actions h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
}

.note-card {
  background: #f9fafb;
  border-radius: 0.375rem;
  padding: 1rem;
}

.note-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.note-type {
  font-weight: 600;
  color: #3b82f6;
  font-size: 0.9rem;
}

.note-date {
  color: #6b7280;
  font-size: 0.85rem;
}

.note-content {
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.6;
}

.followup-date {
  font-weight: 600;
  color: #3b82f6;
  margin-bottom: 0.75rem;
}

.followup-content {
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.6;
}

.symptom-item {
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  margin-bottom: 0.75rem;
}

.symptom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #111827;
}

.severity-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.severity-badge.moderate {
  background: #fef3c7;
  color: #d97706;
}

.severity-badge.mild {
  background: #dbeafe;
  color: #2563eb;
}

.severity-badge.severe {
  background: #fef2f2;
  color: #dc2626;
}

.symptom-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
}

.no-data {
  text-align: center;
  color: #9ca3af;
  font-size: 0.9rem;
  padding: 2rem;
  font-style: italic;
}

.test-card {
  background: #fef2f2;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 4px solid #dc2626;
}

.test-card h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.75rem;
}

.test-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.priority-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  width: fit-content;
}

.priority-badge.high-priority {
  background: #fef2f2;
  color: #dc2626;
}

.priority-badge.medium-priority {
  background: #fef3c7;
  color: #d97706;
}

.test-info {
  font-size: 0.85rem;
  color: #4b5563;
}

.test-info p {
  margin: 0.25rem 0;
}

.schedule-btn {
  background: #dc2626;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.schedule-btn:hover {
  background: #b91c1c;
}

.action-button {
  width: 100%;
  padding: 0.75rem 1rem;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1e40af;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: all 0.2s;
  text-align: left;
}

.action-button:hover {
  background: #dbeafe;
}

/* Insights Tab */
.insights-tab {
  width: 100%;
}

.ai-insights {
  background: white;
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insights-header {
  margin-bottom: 2rem;
}

.insights-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
}

.insights-header p {
  color: #6b7280;
  font-size: 0.95rem;
}

.recommendations-grid {
  display: grid;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.recommendation-card {
  background: #f9fafb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  border-left: 4px solid #3b82f6;
}

.rec-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.rec-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.rec-icon {
  font-size: 1.5rem;
}

.rec-title h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
}

.rec-badges {
  display: flex;
  gap: 0.5rem;
}

.priority-badge.high {
  background: #fef2f2;
  color: #dc2626;
}

.priority-badge.medium {
  background: #fef3c7;
  color: #d97706;
}

.type-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.type-badge.referral {
  background: #ede9fe;
  color: #7c3aed;
}

.type-badge.medication {
  background: #dbeafe;
  color: #2563eb;
}

.type-badge.lifestyle {
  background: #d1fae5;
  color: #059669;
}

.type-badge.monitoring {
  background: #fef3c7;
  color: #d97706;
}

.rec-description {
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.rec-evidence {
  background: white;
  padding: 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.rec-evidence strong {
  color: #111827;
  font-size: 0.9rem;
}

.rec-evidence p {
  color: #6b7280;
  font-size: 0.85rem;
  margin-top: 0.5rem;
  line-height: 1.5;
}

.rec-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.confidence {
  color: #6b7280;
  font-size: 0.9rem;
}

.confidence strong {
  font-weight: 700;
}

.rec-action-btn {
  background: #3b82f6;
  color: white;
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.rec-action-btn:hover {
  background: #2563eb;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.stat-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.stat-number.high-priority {
  color: #dc2626;
}

.stat-number.medication {
  color: #2563eb;
}

.stat-number.lifestyle {
  color: #059669;
}

.stat-number.confidence {
  color: #7c3aed;
}

.stat-label {
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Profile Tab */
.profile-tab {
  width: 100%;
}

.profile-section {
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.profile-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f3f4f6;
}

.demographics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.25rem;
}

.demo-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.demo-item.full-width {
  grid-column: 1 / -1;
}

.demo-item label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.demo-item p {
  font-size: 0.95rem;
  color: #111827;
}

.emergency-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.emergency-info p {
  font-size: 0.95rem;
  color: #4b5563;
}

.medical-history {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.history-item {
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.375rem;
}

.history-item strong {
  display: block;
  margin-bottom: 0.75rem;
  color: #111827;
  font-size: 0.95rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.tag {
  background: #dbeafe;
  color: #1e40af;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.85rem;
  font-weight: 500;
}

.history-list {
  list-style: disc;
  padding-left: 1.5rem;
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.8;
}

.medications-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.25rem;
}

.medication-card {
  background: #eff6ff;
  border-radius: 0.375rem;
  padding: 1.25rem;
  border-left: 4px solid #3b82f6;
}

.medication-card h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.75rem;
}

.medication-card p {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0.375rem 0;
}

.allergies-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.allergy-item {
  background: #fef2f2;
  border-radius: 0.375rem;
  padding: 1rem;
  border-left: 4px solid #dc2626;
}

.allergy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.allergy-header strong {
  color: #111827;
  font-size: 0.95rem;
}

.allergy-item p {
  color: #6b7280;
  font-size: 0.85rem;
}

.insurance-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.insurance-info p {
  font-size: 0.95rem;
  color: #4b5563;
}

.care-team-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.25rem;
}

.team-member {
  background: #f0fdf4;
  border-radius: 0.375rem;
  padding: 1.25rem;
  border-left: 4px solid #10b981;
}

.team-member h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.25rem;
}

.member-role {
  color: #059669;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.team-member p {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0.375rem 0;
}

@media (max-width: 768px) {

  .dashboard-header,
  .patient-overview,
  .tab-content {
    padding: 1rem;
  }

  .patient-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .section-actions {
    width: 100%;
    flex-direction: column;
  }

  .search-input {
    width: 100%;
  }

  .clinical-sidebar {
    grid-template-columns: 1fr;
  }

  .header-controls {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .time-filter-select {
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 0.85rem;
    color: #6b7280;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
  }

  .time-filter-select:hover {
    border-color: #9ca3af;
    background: #f9fafb;
  }

  .time-filter-select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  @media (max-width: 768px) {
    .header-controls {
      flex-direction: column;
      gap: 0.5rem;
    }

    .time-filter-select {
      width: 100%;
    }
  }
 span.multiselect__single {
    text-align: center;
}


}
</style>